<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span epub:type="pagebreak" id="page_vii" title="vii">Contents</span></p>
<p class="tocfmt" id="rsec1"><a href="#/text/Acknowledgments#sec1"><i>Acknowledgments</i></a></p>
<p class="tocfm" id="rsec2"><a href="#/text/Preface#sec2"><i>Preface</i></a></p>
<p class="tocfm" id="rsec3"><a href="#/text/Frontmatter02#sec3"><i>Museum Abbreviations</i></a></p>
<p class="toccht" id="rsec4"><a href="#/text/Introduction#sec4">Introduction</a></p>
<p class="tocch" id="rsec5"><a href="#/text/Chapter01#sec5">1.<span class="spacec">The Paleoenvironments and Stratigraphy of North Africa</span></a></p>
<p class="tocch" id="rsec6"><a href="#/text/Chapter03#sec6">2.<span class="spacec">The Flora of North Africa</span></a></p>
<p class="tocch" id="rsec7"><span href="#/text/Chapter04#sec7" title="Link target outside of Sample">3.<span class="spacec">The Fauna of North Africa: Invertebrates</span></span></p>
<p class="tocch" id="rsec8"><span href="#/text/Chapter06#sec8" title="Link target outside of Sample">4.<span class="spacec">The Fauna of North Africa: Vertebrates (Fish)</span></span></p>
<p class="tocch" id="rsec9"><span href="#/text/Chapter08#sec9" title="Link target outside of Sample">5.<span class="spacec">The Fauna of North Africa: Vertebrates (Tetrapoda)</span></span></p>
<p class="tocch" id="rsec10"><span href="#/text/Chapter09#sec10" title="Link target outside of Sample">6.<span class="spacec">North African Ecology</span></span></p>
<p class="tocch" id="rsec11"><span href="#/text/Chapter10#sec11" title="Link target outside of Sample">7.<span class="spacec">The March of the Oysters</span></span></p>
<p class="tocch" id="rsec12"><span href="#/text/Chapter11#sec12" title="Link target outside of Sample">8.<span class="spacec">The Cenomanian Mass Extinction</span></span></p>
<p class="tocfmt" id="rsec13"><span href="#/text/Appendix#sec13" title="Link target outside of Sample"><i>Appendix</i></span></p>
<p class="tocfm" id="rsec14"><span href="#/text/Literature_Cited#sec14" title="Link target outside of Sample"><i>Literature Cited</i></span></p>
<p class="tocfm" id="rsec15"><span href="#/text/Index#sec15" title="Link target outside of Sample"><i>Index</i><span epub:type="pagebreak" id="page_viii" title="viii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?d843cdd6